import { Field } from "@progress/kendo-react-form";
import TextEditor from "../../Common/TextEditor";

const ACTION_LOWERCASE = "action";
export const ActionNoteTextEditor = () => {
  return (
    <div className="inline-block w-full pt-2 align-top">
      <Field
        id={ACTION_LOWERCASE}
        name={ACTION_LOWERCASE}
        component={TextEditor}
      />
    </div>
  );
};
